import { useState } from 'react';
import { IUser } from '../common';
import { render } from '.';
import { Container, styled, useMediaQuery } from '@mui/material';

export function ViewUser({
  user,
  tabNumber,
}: {
  user: IUser;
  tabNumber: number;
}) {
  const matchesGridBreakpoint = useMediaQuery('(min-width:60em)', {
    noSsr: true,
  });

  const [currentTab, setCurrentTab] = useState(tabNumber);
  const [edit, setEdit] = useState(false);

  return (
    <Container maxWidth="xl" style={{ padding: 0 }}>
      {matchesGridBreakpoint ? (
        <Articl>
          {render({
            user,
            currentTab,
            edit,
            setCurrentTab,
            setEdit,
          })}
        </Articl>
      ) : (
        <article>
          {render({
            user,
            currentTab,
            edit,
            setCurrentTab,
            setEdit,
          })}
        </article>
      )}
    </Container>
  );
}

const Articl = styled('article')(({ theme }) => ({
  border: '2px solid #eeeeee',
  padding: '1.5rem',
  overflow: 'hidden',
  boxShadow: 'none',
  borderRadius: '5px',
}));
